import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  inMemoryPersistence
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDWXPIWP2t2GyJlT7PZUhNfrMJpNVL_gug",
  authDomain: "uvoto-f2570.firebaseapp.com",
  projectId: "uvoto-f2570",
  storageBucket: "uvoto-f2570.firebasestorage.app",
  messagingSenderId: "1005995041070",
  appId: "1:1005995041070:web:6abe5baebd4ab291b1dabf"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// uvotoTv es exactamente lo que carga el widget de embed (AdminQuickConnect)
// dentro de un <iframe> en el sitio de otra persona — un contexto de terceros
// donde Safari ITP y el storage partitioning de Chrome pueden bloquear
// IndexedDB por completo. Antes usábamos getAuth() + setPersistence() async,
// pero eso deja una ventana de carrera: si signInAnonymously() se dispara
// antes de que la promesa de setPersistence resuelva, sigue intentando la
// persistencia rota. initializeAuth() con una cadena de fallback configura
// esto de forma síncrona desde el arranque — prueba IndexedDB, luego
// localStorage, luego sessionStorage y por último memoria (no sobrevive un
// reload, pero el login sí es real dentro de esa carga de página, que es lo
// único que necesita un widget de chat embebido).
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence, inMemoryPersistence]
});